export default {"announcementsSubreddit":"RESAnnouncements","name":"Reddit Enhancement Suite","version":"5.10.3","isBeta":false,"isPatch":true,"isMinor":false,"isMajor":false,"updatedURL":"https://redditenhancementsuite.com/releases/#v5.10.3","homepageURL":"https://redditenhancementsuite.com","gitDescription":"v5.10.3"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/exec-loader?cache!./lib/core/metadata/packageInfo.js
// module id = null
// module chunks = 